<script setup>
import { useStore } from "@/store";
const store = useStore()
</script>

<template>
  <span role="button" class="text-white"  @click="store.toggleTheme()" title="Переключить тему">
    <i class="bi" :class="store.isDarkTheme ? 'bi-sun-fill theme-toggler' : 'bi-moon-fill theme-toggler'"></i>
  </span>
</template>
